import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-20 pb-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {t('hero.title1')}
                <span className="text-primary"> {t('hero.title2')}</span>
                <br />
                <span className="text-secondary">{t('hero.title3')}</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {t('hero.subtitle')}
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-primary w-5 h-5" />
                <span className="text-gray-700">{t('hero.prediscovery')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-primary w-5 h-5" />
                <span className="text-gray-700">{t('hero.endtoend')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-primary w-5 h-5" />
                <span className="text-gray-700">{t('hero.agile')}</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToContact}
                size="lg"
                className="bg-primary hover:bg-primary/90 text-white group transition-all duration-300"
                aria-label={t('hero.cta1')}
              >
                {t('hero.cta1')}
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
              </Button>
              <Button 
                onClick={() => document.getElementById('sobre').scrollIntoView({ behavior: 'smooth' })}
                variant="outline" 
                size="lg"
                className="border-primary text-primary hover:bg-primary/5 transition-all duration-300"
              >
                {t('hero.cta2')}
              </Button>
            </div>
          </div>

          {/* Right Content - Illustration */}
          <div className="relative">
            <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl p-8 backdrop-blur-sm">
              <div className="space-y-6">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="w-8 h-8 bg-primary/20 rounded-lg mb-3"></div>
                    <div className="text-sm font-medium text-gray-900">{t('services.consulting.title').split(' ')[0]}</div>
                    <div className="text-xs text-gray-600">{t('services.consulting.title').split(' ')[1]}</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="w-8 h-8 bg-secondary/20 rounded-lg mb-3"></div>
                    <div className="text-sm font-medium text-gray-900">Cloud AWS</div>
                    <div className="text-xs text-gray-600">{t('services.cloud.title').split(' ')[2]}</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="w-8 h-8 bg-primary/20 rounded-lg mb-3"></div>
                    <div className="text-sm font-medium text-gray-900">{t('services.development.title').split(' ')[0]}</div>
                    <div className="text-xs text-gray-600">{t('services.development.title').split(' ').slice(1).join(' ')}</div>
                  </div>
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="w-8 h-8 bg-secondary/20 rounded-lg mb-3"></div>
                    <div className="text-sm font-medium text-gray-900">{t('services.modernization.title').split(' ')[0]}</div>
                    <div className="text-xs text-gray-600">{t('services.modernization.title').split(' ')[1]}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};